module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-body"
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "md": 8
    }
  }, [_c('h1', {
    staticClass: "pageTitle"
  }, [_c('i', {
    staticClass: "fa fa-cubes",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(!_vm.isCreditNote ?
    _vm.$t('static.bills.edit.title') : _vm.$t('static.bills.edit.creditNoteTitle')) + " " + _vm._s(_vm.currentBill.billingNumber ?
    ("#" + (_vm.currentBill.billingNumber)) : ''))])])], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "background": "transparent"
    }
  }, [_c('br'), _c('br')]) : _c('div', {
    staticClass: "whiteWrapper"
  }, [_c('el-tabs', {
    model: {
      value: (_vm.tabIndex),
      callback: function($$v) {
        _vm.tabIndex = $$v
      },
      expression: "tabIndex"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('static.bills.formTabs.invoiceInformation'),
      "name": "1"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [(_vm.currentOrder) ? _c('el-col', {
    attrs: {
      "lg": 16
    }
  }, [(_vm.isClientContactEmailMissing && _vm.isInvoice && !['EHF', 'EDI'].includes(_vm.currentBill.sendVia.toUpperCase())) ? _c('div', {
    staticClass: "account_alert"
  }, [_vm._v(_vm._s(_vm.$t('static.alertMissingDetails.customerNoContactEmail.message')) + " "), _c('router-link', {
    staticClass: "alert-warning-link",
    attrs: {
      "to": {
        name: 'clients.edit',
        params: {
          id: _vm.currentClient.id
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('static.alertMissingDetails.customerNoContactEmail.linkText')))])], 1) : _vm._e(), _vm._v(" "), (_vm.returnWarning && _vm.isCreditNote && !['EHF', 'EDI'].includes(_vm.currentBill.sendVia.toUpperCase())) ? _c('div', {
    staticStyle: {
      "padding": "10px",
      "text-align": "left",
      "border": "1px solid #e84c4c",
      "background": "#F56C6C",
      "color": "#fff",
      "font-size": "16px",
      "margin-bottom": "30px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.returnWarning)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showOverdueInvoiceNotice) ? _c('div', {
    staticClass: "account_alert",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('static.bills.edit.overdueInvoiceNotice')) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t('static.bills.edit.detailsLegend')))]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "md": 8
    }
  }, [_c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-clock-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.bills.edit.billStatus')) + ":\n                    ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small",
    class: _vm.currentOrdeStatus.toLowerCase()
  }, [_vm._v("\n                      " + _vm._s(_vm.$t(("static.reports.bills." + (_vm.currentOrdeStatus.replace(/\s+/g, '').toLowerCase())))) + " " + _vm._s(_vm.currentBill.sendVia && _vm.currentBill.sendVia != '' ? ("via " + (_vm.currentBill.sendVia.toUpperCase())) : '') + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-calendar",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.bills.edit.date')) + ":\n                    ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small"
  }, [_vm._v("\n                      " + _vm._s(_vm.isValidDate(_vm.currentBill.date) ? _vm.formatDate(_vm.currentBill.date) : '-') + "\n                    ")])]), _vm._v(" "), (!_vm.isCreditNote) ? _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-calendar",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.bills.edit.dueDate')) + ":\n                    ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small",
    class: {
      'bill-invoice-due-overdue': _vm.invoiceDueDateIsOverdue
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.isValidDate(_vm.currentBill.dueDate) ? _vm.formatDate(_vm.currentBill.dueDate) : '-') + "\n                      "), (_vm.invoiceDueDateIsOverdue) ? _c('span', {
    staticClass: "bill-overdue-badge bill-overdue-badge--detail"
  }, [_vm._v(" " + _vm._s(_vm.$t('static.bills.edit.overdueBadge')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.isValidDate(_vm.currentBill.paymentDate)) ? _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-calendar",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.bills.edit.paymentDate')) + ":\n                    ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function () { return _vm.tabIndex = '2'; }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.isValidDate(_vm.currentBill.paymentDate) ? _vm.formatDate(_vm.currentBill.paymentDate) : '-') + "\n                      ")])])]) : _vm._e(), _vm._v(" "), (_vm.isEdiOrder) ? _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-truck",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.bills.edit.deliveredTo')) + ":\n                    ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small"
  }, [_vm._v("\n                      " + _vm._s(_vm.currentOrder.clientName) + ", " + _vm._s(_vm.currentOrder.ediStore) + "\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.currentBill.note) ? _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-sticky-note-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.bills.edit.orderReference')) + ":\n                    ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small"
  }, [_vm._v("\n                      " + _vm._s(_vm.currentBill.note) + "\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.currentBill.paymentMessage) ? _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-envelope-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('form.bills.paymentMessage.label')) + ":\n                    ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small"
  }, [_vm._v("\n                      " + _vm._s(_vm.currentBill.paymentMessage) + "\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.currentBill.billStatus != 'Draft' && (_vm.settings.paymentIdentitificationGeneration || _vm.currentBill.kidNumber)) ? _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-hashtag",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('form.bills.kidNumber.label')) + ":\n                    ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small"
  }, [_vm._v("\n                      " + _vm._s(_vm.currentBill.kidNumber) + "\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.creditNotes && _vm.creditNotes.length) ? _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-id-card-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.creditNotes')) + ":\n                    ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small"
  }, [_vm._l((_vm.creditNotes), function(c, i) {
    return [_c('router-link', {
      attrs: {
        "to": {
          name: 'bills.creditNote',
          params: {
            id: c.id
          }
        }
      }
    }, [_vm._v("\n                          " + _vm._s(c.billing_number ? ("#" + (c.billing_number)) : ((_vm.$t('static.reports.bills.draft')) + " " + (i + 1))) + "\n                        ")]), _vm._v(" "), (i < _vm.creditNotes.length - 1) ? _c('span', [_vm._v(" | ")]) : _vm._e()]
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.currentBill.sourceBillNumber) ? _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-id-card-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.bills.edit.invoiceNumber')) + ":\n                    ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'bills.edit',
        params: {
          id: _vm.currentBill.creditNoteSource
        }
      }
    }
  }, [_vm._v("\n                        #" + _vm._s(_vm.currentBill.sourceBillNumber) + "\n                      ")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.isCreditNote && _vm.currentBill.creditNoteReason) ? _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-id-card-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.bills.edit.creditNoteReason')) + ":\n                    ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small"
  }, [_vm._v("\n                      " + _vm._s(_vm.currentBill.creditNoteReason.name) + "\n                    ")])]) : _vm._e()]), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 16
    }
  }, [_c('div', {
    staticClass: "full-w flex wrap justify-end bill-toolbar-actions"
  }, [(_vm.isDraft) ? _c('el-button', {
    staticClass: "small dark-outline margin-b-10",
    attrs: {
      "icon": "el-icon-close"
    },
    on: {
      "click": function($event) {
        return _vm.deleteBill(_vm.currentBill)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isDraft && _vm.isCreditNote) ? _c('el-button', {
    staticClass: "small margin-b-10",
    attrs: {
      "loading": _vm.submitLoading,
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.save('Pending')
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.$t('button.save')) + "\n                    ")]) : _vm._e(), _vm._v(" "), _c('v-message', {
    attrs: {
      "info": _vm.previewWait,
      "customClass": "preview-msg-alert"
    }
  }), _vm._v(" "), _c('v-message', {
    attrs: {
      "success": _vm.successMessage
    }
  }), _vm._v(" "), (_vm.showEhfModuleUpsellBanner) ? _c('el-alert', {
    staticClass: "margin-b-10 bill-ehf-info-alert",
    attrs: {
      "type": "info",
      "closable": false,
      "show-icon": "",
      "title": _vm.ehfModuleUpsellCustomerVerified ? _vm.$t('static.bills.edit.ehfModuleUpsellTitle') : _vm.$t('static.bills.edit.ehfModuleUpsellTitleNoPeppolYet')
    }
  }, [_c('p', {
    staticClass: "margin-b-0"
  }, [_vm._v(_vm._s(_vm.ehfModuleUpsellCustomerVerified ?
    _vm.$t('static.bills.edit.ehfModuleUpsellBody') :
    _vm.$t('static.bills.edit.ehfModuleUpsellBodyNoPeppolYet')))]), _vm._v(" "), _c('p', {
    staticClass: "margin-t-10 margin-b-0"
  }, [_c('a', {
    staticClass: "alert-warning-link",
    attrs: {
      "role": "button",
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showEHFModuleModal($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('static.bills.edit.ehfModuleUpsellLink')))])])]) : _vm._e(), _vm._v(" "), (_vm.showEhfPendingVerificationBanner) ? _c('el-alert', {
    staticClass: "margin-b-10 bill-ehf-warning-alert",
    attrs: {
      "type": "warning",
      "closable": false,
      "show-icon": "",
      "title": _vm.$t('static.bills.edit.ehfNotVerifiedTitle')
    }
  }, [_c('p', {
    staticClass: "margin-b-0"
  }, [_vm._v(_vm._s(_vm.$t('static.bills.edit.ehfNotVerifiedBody')))]), _vm._v(" "), (!_vm.currentClient.email) ? _c('p', {
    staticClass: "margin-b-10 margin-t-10"
  }, [_vm._v(_vm._s(_vm.$t('static.bills.edit.ehfNotVerifiedNoEmail')))]) : _vm._e(), _vm._v(" "), (_vm.currentClient && _vm.currentClient.id) ? _c('router-link', {
    staticClass: "alert-warning-link",
    attrs: {
      "to": {
        name: 'clients.edit',
        params: {
          id: _vm.currentClient.id
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('static.bills.edit.ehfNotVerifiedClientLink')))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.showEhfPreferredOverEmailBanner) ? _c('el-alert', {
    staticClass: "margin-b-10 bill-ehf-info-alert",
    attrs: {
      "type": "info",
      "closable": false,
      "show-icon": "",
      "title": _vm.$t('static.bills.edit.ehfPreferredOverEmailTitle')
    }
  }, [_c('p', {
    staticClass: "margin-b-0"
  }, [_vm._v(_vm._s(_vm.$t('static.bills.edit.ehfPreferredOverEmailBody')))]), _vm._v(" "), (!_vm.currentClient.email) ? _c('p', {
    staticClass: "margin-b-10 margin-t-10"
  }, [_vm._v(_vm._s(_vm.$t('static.bills.edit.ehfPreferredOverEmailNoEmail')))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "margin-t-10 bill-ehf-preferred-actions"
  }, [_c('el-button', {
    staticClass: "small",
    attrs: {
      "type": "primary",
      "loading": _vm.sendEHFLoading,
      "disabled": !(_vm.billProducts.length > 0 || _vm.orderProducts.length > 0) || (_vm.isCreditNote && !_vm.hasCreditNoteReason)
    },
    on: {
      "click": _vm.sendEHFInvoice
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.$t('static.bills.edit.ehfPreferredOverEmailSendEhfBtn')) + "\n                        ")]), _vm._v(" "), _c('el-button', {
    staticClass: "small",
    attrs: {
      "loading": _vm.sendLoading,
      "disabled": !_vm.currentClient.email || !(_vm.billProducts.length > 0 || _vm.orderProducts.length > 0) || (_vm.isCreditNote && !_vm.hasCreditNoteReason)
    },
    on: {
      "click": _vm.previewSendInvoice
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.isCreditNote ? _vm.$t('static.bills.edit.ehfPreferredOverEmailSendCreditNoteEmailBtn') : _vm.$t('static.bills.edit.ehfPreferredOverEmailSendInvoiceEmailBtn')) + "\n                        ")])], 1)]) : _vm._e(), _vm._v(" "), (!_vm.hasCreditNoteReason && _vm.isCreditNote && typeof(_vm.currentOrder) !== 'undefined' && !_vm.isDraft) ? _c('el-button', {
    staticClass: "small margin-b-10",
    attrs: {
      "disabled": !(_vm.billProducts.length > 0 || _vm.orderProducts.length > 0)
    },
    on: {
      "click": _vm.submitCreditNoteReason
    }
  }, [_vm._v(_vm._s(_vm.$t('button.creditNoteReason')))]) : _vm._e(), _vm._v(" "), ((_vm.invoiceSendMethodIsEmail || _vm.showSendInvoiceEmailFallbackForEhf) && !_vm.showEhfPreferredOverEmailBanner && ((_vm.isCreditNote && _vm.isPending) || (!_vm.isCreditNote && _vm.isPending)) && _vm.currentClient.email && typeof(_vm.currentOrder) !== 'undefined' && !_vm.isEdiOrder) ? _c('el-button', {
    staticClass: "small margin-b-10",
    attrs: {
      "loading": _vm.sendLoading,
      "disabled": !(_vm.billProducts.length > 0 || _vm.orderProducts.length > 0) || (_vm.isCreditNote && !_vm.hasCreditNoteReason)
    },
    on: {
      "click": _vm.previewSendInvoice
    }
  }, [(_vm.showSendInvoiceEmailFallbackForEhf) ? [_vm._v("\n                        " + _vm._s(_vm.isCreditNote ? _vm.$t('static.bills.edit.sendCreditNoteEmailFallbackBtn') : _vm.$t('static.bills.edit.sendInvoiceEmailFallbackBtn')) + "\n                      ")] : [_vm._v("\n                        " + _vm._s(_vm.isCreditNote ? _vm.$t('static.bills.edit.sendCreditNoteBtn') :
    _vm.$t('static.bills.edit.sendInvoiceBtn')) + "\n                      ")]], 2) : _vm._e(), _vm._v(" "), (_vm.hasEHFModule && _vm.isPending && _vm.invoiceSendMethodIsEhf && _vm.currentClient.ehfBilling3_0 && typeof(_vm.currentOrder) !== 'undefined' && !_vm.isEdiOrder) ? _c('el-button', {
    staticClass: "small warning margin-b-10",
    staticStyle: {
      "background-color": "#ffb000",
      "border-color": "1px solid #ff9c00",
      "color": "#6f4800"
    },
    attrs: {
      "loading": _vm.sendEHFLoading,
      "disabled": !(_vm.billProducts.length > 0 || _vm.orderProducts.length > 0) || (_vm.isCreditNote && !_vm.hasCreditNoteReason)
    },
    on: {
      "click": _vm.sendEHFInvoice
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.$t('static.bills.edit.sendEhfInvoiceBtn')) + "\n                    ")]) : _vm._e(), _vm._v(" "), (!_vm.isCreditNote && _vm.isSent && (_vm.invoiceSendMethodIsEmail ? _vm.currentClient.email : _vm.invoiceSendMethodIsEhf) && typeof(_vm.currentOrder) !== 'undefined' && !_vm.isEdiOrder) ? _c('div', {
    staticClass: "btn-group margin-b-10 margin-r-10"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "disabled": "",
      "type": "button"
    }
  }, [_vm._v(_vm._s(_vm.$t('static.bills.edit.invoiceSent')) + " " + _vm._s(_vm.invoiceSentAt))]), _vm._v(" "), _c('el-button', {
    staticClass: "btn btn-danger dropdown-toggle dropdown-toggle-split",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    },
    on: {
      "click": _vm.toggleDropdown
    }
  }, [_c('span', {
    staticClass: "sr-only"
  })]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu",
    class: {
      show: _vm.dropdownState
    }
  }, [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showInvoice()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('static.bills.edit.showInvoiceBtn')))]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "role": "button"
    },
    on: {
      "click": _vm.downloadInvoice
    }
  }, [_vm._v(_vm._s(_vm.$t('static.bills.edit.downloadInvoiceBtn')))]), _vm._v(" "), (_vm.showCreateReminderButton) ? _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "role": "button"
    },
    on: {
      "click": _vm.createBillReminder
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.$t('button.createReminder')) + "\n                        ")]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (typeof(_vm.currentOrder) !== 'undefined' && _vm.isEdiOrder && _vm.isPending) ? _c('el-button', {
    staticClass: "small margin-b-10",
    attrs: {
      "loading": _vm.sendLoading,
      "disabled": !_vm.billProducts.length > 0 || (_vm.isCreditNote && !_vm.hasCreditNoteReason)
    },
    on: {
      "click": _vm.sendBillEDI
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.isCreditNote ? _vm.$t('static.bills.edit.sendEdiCreditNoteBtn') :
    _vm.$t('static.bills.edit.sendEdiInvoiceBtn')) + "\n                    ")]) : _vm._e(), _vm._v(" "), (!_vm.isEdiOrder) ? _c('el-button', {
    staticClass: "small margin-b-10",
    attrs: {
      "disabled": Object.keys(_vm.currentOrder).length === 0
    },
    on: {
      "click": function($event) {
        return _vm.showInvoice()
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.isCreditNote ? _vm.$t('static.bills.edit.showCreditNoteBtn') : _vm.$t('static.bills.edit.showInvoiceBtn')) + "\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.isEdiOrder) ? _c('div', {
    staticClass: "btn-group margin-b-10"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "disabled": "",
      "type": "button"
    }
  }, [_vm._v(_vm._s(_vm.isCreditNote ?
    _vm.$t('static.bills.edit.showCreditNoteBtn') : _vm.$t('static.bills.edit.showInvoiceBtn')))]), _vm._v(" "), _c('el-button', {
    staticClass: "btn btn-danger dropdown-toggle dropdown-toggle-split",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    },
    on: {
      "click": _vm.toggleDropdown
    }
  }, [_c('span', {
    staticClass: "sr-only"
  })]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu",
    class: {
      show: _vm.dropdownState
    }
  }, [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showInvoice()
      }
    }
  }, [_vm._v(_vm._s(_vm.isCreditNote ?
    _vm.$t('static.bills.edit.showCreditNoteBtn') : _vm.$t('static.bills.edit.showInvoiceBtn')))]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "role": "button"
    },
    on: {
      "click": _vm.downloadInvoice
    }
  }, [_vm._v(_vm._s(_vm.isCreditNote ?
    _vm.$t('static.bills.edit.downloadCreditNoteBtn') :
    _vm.$t('static.bills.edit.downloadInvoiceBtn')))])])], 1) : _vm._e(), _vm._v(" "), ((_vm.isSent || _vm.isPartlyPaid) && !_vm.isCreditNote) ? _c('el-button', {
    staticClass: "small margin-b-10",
    attrs: {
      "loading": _vm.form.loading === 'Cleared',
      "disabled": Object.keys(_vm.currentOrder).length === 0
    },
    on: {
      "click": _vm.markAsCleared
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.$t('button.markAsCleared')) + "\n                    ")]) : _vm._e(), _vm._v(" "), (!_vm.isCreditNote) ? _c('el-button', {
    staticClass: "small margin-b-10",
    attrs: {
      "loading": _vm.loadingCreditNote,
      "disabled": Object.keys(_vm.currentOrder).length === 0
    },
    on: {
      "click": _vm.createCreditNote
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.$t('static.bills.edit.createCreditNoteBtn')) + "\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.currentBill.billStatus != 'Draft' && _vm.settings.paymentIdentitificationGeneration && _vm.settings.paymentIdentitificationGeneration) ? [(_vm.currentBill.kidNumber) ? _c('el-button', {
    staticClass: "small margin-b-10",
    attrs: {
      "loading": _vm.kidLoading
    },
    on: {
      "click": _vm.validateKidNumber
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('static.bills.edit.validateKidNumber')) + "\n                      ")]) : _c('el-button', {
    staticClass: "small margin-b-10",
    attrs: {
      "loading": _vm.kidLoading
    },
    on: {
      "click": _vm.generateKidNumber
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('static.bills.edit.generateKidNumber')) + "\n                      ")])] : _vm._e()], 2)])], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('el-col', {
    staticClass: "blockmainWrapper",
    attrs: {
      "lg": 8
    }
  }, [_c('v-client-info', {
    attrs: {
      "client": _vm.currentClient,
      "billId": _vm.currentBill.id,
      "currentEdiOrder": _vm.currentOrder
    }
  })], 1), _vm._v(" "), (Object.keys(_vm.currentOrder).length > 0) ? _c('el-col', [_c('div', {
    staticClass: "bill-lines-card"
  }, [_c('h3', {
    staticClass: "bill-lines-title"
  }, [_vm._v(_vm._s(_vm.$t('static.bills.billLines')))]), _vm._v(" "), _c('el-row', [(!_vm.loading && (!_vm.isCreditNote || (_vm.currentOrder.ediType == 'ZKA' || _vm.currentOrder.ediType == 'ZRE'))) ? _c('v-products-table', {
    attrs: {
      "order": _vm.currentOrder,
      "bill": _vm.currentBill,
      "billRoundInvoiceTotal": _vm.currentBill.roundInvoiceTotal
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.loading && (_vm.isCreditNote && _vm.currentOrder.ediType != 'ZKA' && _vm.currentOrder.ediType != 'ZRE')) ? _c('v-credit-note-table', {
    attrs: {
      "order": _vm.currentOrder,
      "bill": _vm.currentBill,
      "billRoundInvoiceTotal": _vm.currentBill.roundInvoiceTotal
    }
  }) : _vm._e(), _vm._v(" "), ((_vm.isDraft || _vm.isPending) && (typeof(_vm.currentOrder) !== 'undefined' && !_vm.isEdiOrder)) ? _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "name": "roundInvoiceTotal"
    },
    on: {
      "change": _vm.roundInvoice
    },
    model: {
      value: (_vm.roundInvoiceTotal),
      callback: function($$v) {
        _vm.roundInvoiceTotal = $$v
      },
      expression: "roundInvoiceTotal"
    }
  }), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.$t('static.orders.edit.roundInvoiceTotal')))])], 1) : _vm._e()], 1)], 1)]) : _vm._e()], 1)], 1), _vm._v(" "), (!_vm.isEdiOrder && !_vm.isCreditNote) ? _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('static.bills.formTabs.reminders'),
      "name": "4"
    }
  }, [_c('div', [(_vm.canSendPaymentReminderActions) ? _c('el-button', {
    staticClass: "el-button small margin-b-10 el-button--button",
    attrs: {
      "loading": _vm.sendReminderPreviewLoading
    },
    on: {
      "click": _vm.sendReminderPreview
    }
  }, [_vm._v(_vm._s(_vm.$t('static.bills.edit.sendReminder')))]) : _vm._e(), _vm._v(" "), (_vm.canSendPaymentReminderActions) ? _c('el-button', {
    staticClass: "el-button small margin-b-10 el-button--button",
    on: {
      "click": function($event) {
        return _vm.showInvoice(true)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('static.bills.edit.invoiceWithReminderFee')))]) : _vm._e()], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.billReminders,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm.$t('static.reminderTable.reminder')) + " " + _vm._s(scope.$index + 1))]
      }
    }], null, false, 2827682467)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('h4', [_c('strong', [_vm._v(_vm._s(_vm.$t('static.reminderTable.notes')) + ":")])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(props.row.notes))])]
      }
    }], null, false, 599892944)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('static.reminderTable.type'),
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.penalty_fee_id ? _vm.$t(("static.reminderTable." + (scope.row.penaltyFee.type))) : '--'))])]
      }
    }], null, false, 4255879427)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('static.reminderTable.freeAmount'),
      "width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.penalty_fee_id && scope.row.fee_amount == 0) ? _c('span', [_vm._v("--")]) : (scope.row.penaltyFee.type == 'percentage') ? _c('span', [_vm._v("\n              " + _vm._s(((scope.row.fee_amount) + " " + _vm.currency + " "))), _c('strong', [_vm._v(_vm._s(("(" + (scope.row.penaltyFee.fee_rate) + "% of " + (scope.row.bill_amount.toFixed(2)) + " " + _vm.currency + ")")))])]) : _c('span', [_vm._v(_vm._s(((scope.row.fee_amount) + " " + _vm.currency)))])]
      }
    }], null, false, 3482646224)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "date",
      "label": _vm.$t('static.reminderTable.dateCreated')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('static.reminderTable.newDueDate')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.newDueDate ? scope.row.newDueDate : '--'))])]
      }
    }], null, false, 2761063459)
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('static.bills.formTabs.edit'),
      "name": "2"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('v-form', {
    attrs: {
      "form": _vm.form,
      "translation": "form.bills",
      "hasLabel": true
    }
  }), _vm._v(" "), (_vm.isDraft) ? _c('el-button', {
    attrs: {
      "loading": _vm.form.loading === 'Draft',
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.save('Draft')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('button.saveDraft')))]) : _vm._e(), _vm._v(" "), ((_vm.isDraft || _vm.isPending) && !_vm.isCreditNote) ? _c('el-button', {
    attrs: {
      "loading": _vm.form.loading === 'Pending',
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.save('Pending')
      }
    }
  }, [_vm._v(_vm._s(_vm.isDraft ? _vm.$t('button.createInvoice') : _vm.$t('button.updateInvoice')))]) : _vm._e(), _vm._v(" "), (_vm.isCleared && !_vm.isCreditNote) ? _c('el-button', {
    attrs: {
      "loading": _vm.form.loading === 'Pending',
      "type": "primary"
    },
    on: {
      "childSave": _vm.save,
      "click": function($event) {
        return _vm.save('Cleared')
      }
    }
  }, [_vm._v(_vm._s(_vm.isDraft ? _vm.$t('button.createInvoice') : _vm.$t('button.updateInvoice')))]) : _vm._e(), _vm._v(" "), ((_vm.isDraft || _vm.isPending) && _vm.isCreditNote) ? _c('el-button', {
    attrs: {
      "loading": _vm.form.loading === 'Pending',
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.save('Pending')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('button.save')))]) : _vm._e(), _vm._v(" "), (_vm.isSent) ? _c('el-button', {
    attrs: {
      "loading": _vm.form.loading === 'Cleared',
      "type": "primary"
    },
    on: {
      "click": _vm.markAsCleared
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('button.markAsCleared')) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('v-message', {
    attrs: {
      "success": _vm.successMessage
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('static.bills.formTabs.emails'),
      "name": "3"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, _vm._l((_vm.emailCopies), function(item, key) {
    return _c('el-col', {
      key: key,
      attrs: {
        "xs": 24,
        "sm": 12,
        "md": 6,
        "lg": 6
      }
    }, [_c('div', {
      staticClass: "card-header",
      class: _vm.emailCopyClass[key],
      on: {
        "click": function($event) {
          return _vm.recipients(item.tracking.email_tracking_recipients, key)
        }
      }
    }, [_c('el-card', {
      staticClass: "box-card",
      staticStyle: {
        "margin-bottom": "1em",
        "width": "100%"
      }
    }, [_c('div', {
      staticClass: "clearfix",
      staticStyle: {
        "position": "relative"
      },
      attrs: {
        "slot": "header"
      },
      slot: "header"
    }, [_c('span', [_c('strong', [_vm._v(_vm._s(item.subject))])]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.send_after_date))]), _vm._v(" "), _c('span', {
      staticClass: "mail-status",
      class: item.sent == 1 ? 'sent' : 'queued'
    }, [_vm._v(_vm._s(item.sent == 1 ? 'Sent' : 'Queued'))]), _vm._v(" "), _c('el-button', {
      staticClass: "view-message",
      attrs: {
        "size": "mini"
      },
      on: {
        "click": function($event) {
          return _vm.previewMailTracking(item)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.$t('button.view')) + "\n                  ")])], 1), _vm._v(" "), _c('div', {
      staticClass: "text item"
    }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.$t('static.bills.edit.emailTracking.delivered')) + ": ")]), _vm._v(_vm._s((item.tracking) ? item.tracking.delivered : 0))]), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.$t('static.bills.edit.emailTracking.opened')) + ": ")]), _vm._v(_vm._s((item.tracking) ? item.tracking.opened : 0))]), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.$t('static.bills.edit.emailTracking.clicked')) + ": ")]), _vm._v(_vm._s((item.tracking) ? item.tracking.clicked : 0))]), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.$t('static.bills.edit.emailTracking.dropped')) + ": ")]), _vm._v(_vm._s((item.tracking) ? item.tracking.dropped : 0))]), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.$t('static.bills.edit.emailTracking.bounced')) + ": ")]), _vm._v(_vm._s((item.tracking) ? item.tracking.bounced : 0))]), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.$t('static.bills.edit.emailTracking.complained')) + ": ")]), _vm._v(_vm._s((item.tracking) ? item.tracking.complained : 0))]), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.$t('static.bills.edit.emailTracking.failed')) + ": ")]), _vm._v(_vm._s((item.tracking) ? item.tracking.failed : 0))])])])], 1)])
  }), 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.emailTrackingRecipients,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "recipient",
      "label": _vm.$t('static.bills.edit.emailTracking.recipient')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "email_event_type.name",
      "label": _vm.$t('static.bills.edit.emailTracking.type')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "event_timestamp",
      "label": _vm.$t('static.bills.edit.emailTracking.date')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "device_type.name",
      "label": _vm.$t('static.bills.edit.emailTracking.device')
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a2f5897","hasScoped":true}!./src/app/pages/withNavigation/bills/edit/edit.html
// module id = 3048
// module chunks = 1